import React from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import { isInTable, isInTabs, isInToggleList } from '../../../utils';
import ImageComponentEditable from './ImageEditable';
import ImageComponentReadOnly from './ImageReadOnly';

const ImageNodeView: React.FC = () => {
  const { node, view, getPos } = useReactNodeView();

  const showFullWidth =
    typeof getPos === 'function' &&
    (isInTable(view, getPos()) || isInTabs(view, getPos()) || isInToggleList(view, getPos()));

  if (!view?.editable) {
    return <ImageComponentReadOnly {...node?.attrs} showFullWidth={showFullWidth} />;
  }

  return <ImageComponentEditable {...node?.attrs} showFullWidth={showFullWidth} />;
};

export default ImageNodeView;
